/// <reference path="../../typings/index.d.ts" />
"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var lodash_1 = require("lodash");
var React = require("react");
//require('react-selectize/themes/default.css');
// TODO we should be able to use the line above, but it cssify doesn't handle it,
// so we need to use the line below.
// Issue: https://github.com/davidguttman/cssify/issues/23
// Possibly related issue: https://github.com/davidguttman/cssify/issues/46
// browserify-css has the same problem:
// https://github.com/cheton/browserify-css/issues/46
// NOTE: requires copying the files
require('./react-selectize-theme-default.css');
// this doesn't work when bridgedb is a dependency:
//require('../../node_modules/react-selectize/themes/default.css');
var BDB = 'http://vocabularies.bridgedb.org/ops#';
var SimpleSelect = require('react-selectize').SimpleSelect;
function arrayifyClean(input) {
    if (lodash_1.isArray(input)) {
        return input;
    }
    if (input) {
        return [input];
    }
    return [];
}
var DataSourceSelect = (function (_super) {
    __extends(DataSourceSelect, _super);
    function DataSourceSelect(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            bridgeDb: props.bridgeDb,
            dataSources: [],
            selected: {
                label: props.dataSource,
                value: props.dataSource
            }
        };
        return _this;
    }
    DataSourceSelect.prototype.getOptionsByEntityType = function (entityType) {
        var that = this;
        var dataSources = that.state.dataSources;
        // if dataSources not yet loaded, just return selected item
        var selected = that.state.selected;
        if (dataSources.length === 0) {
            return [selected];
        }
        // return all if no entityReference type specified
        if (!entityType) {
            return dataSources
                .map(function (ds) {
                return {
                    label: ds.conventionalName,
                    value: ds.conventionalName
                };
            });
        }
        return dataSources
            .filter(function (candidateDatasource) {
            // Filtering datasources based on the currently
            // selected GPML DataNode Type
            var candidateDatasourceSubjects = arrayifyClean(candidateDatasource.subject);
            // We include the currently selected entry
            // regardless of entityReference type
            if (candidateDatasource.about === selected.value) {
                return true;
            }
            // We include all Datasources when GPML DataNode Type is equal to
            // one of these entries (using WP vocab):
            var includeAllForTheseTerms = [
                'Complex',
                'Unknown',
            ];
            if (includeAllForTheseTerms.indexOf(entityType) > -1) {
                return true;
            }
            if (candidateDatasourceSubjects.indexOf(entityType) > -1) {
                return true;
            }
            // NOTE: we are intentionally filtering out datasources that lack a subject.
            // That's a BridgeDb curation issue, not an issue for this client.
            return false;
        })
            .map(function (ds) {
            return {
                label: ds.conventionalName,
                value: ds.conventionalName
            };
        });
    };
    DataSourceSelect.prototype.render = function () {
        var that = this;
        var state = that.state;
        var currentOptions = that.getOptionsByEntityType(that.props.entityType);
        return React.createElement(SimpleSelect, { ref: "select", value: state.selected, onValueChange: function (selected) {
                if (!!selected && selected.hasOwnProperty('value')) {
                    that.setState({ selected: selected });
                    that.props.updateHandler(selected.value);
                }
                else {
                    that.setState({ selected: undefined });
                    that.props.updateHandler(undefined);
                }
            }, placeholder: "Select datasource", theme: "default" }, currentOptions.map(function (o) { return React.createElement("option", { key: o.label, value: o.value }, o.label); }));
    };
    DataSourceSelect.prototype.componentDidMount = function () {
        var that = this;
        var props = that.props;
        // using WP vocab
        var geneProductishTerms = [
            'GeneProduct',
            'Protein',
            'Rna',
        ];
        that.state.bridgeDb.sourceDataSources(props.organism)
            .filter(function (ds) {
            // a datasource must have an ID (RDF:about) from identifiers.org to be useful here
            return !!ds.about;
        })
            .filter(function (ds) {
            // we only want primary datasources
            return ds.primary;
        })
            .filter(function (ds) {
            // A datasource having one of the following subjects should NOT be used
            // to identify an Entity Reference for a gpml:DataNode.
            return [
                'interaction',
                'ontology',
                'probe',
                'experiment',
                'publication',
                'model',
                'organism'
            ].indexOf(ds[BDB + 'type']) === -1;
        })
            .map(function (ds) {
            var subjects = arrayifyClean(ds.subject);
            // AP requested to interpret broadly for GeneProduct-related items,
            // so if the entityType is GeneProduct-related, we allow the user
            // to specify the DataSource with any GeneProduct-related DataSource,
            // e.g., Ensembl for a Protein or UniProt-Trembl for a GeneProduct.
            if (lodash_1.intersection(subjects, geneProductishTerms).length > 0) {
                ds.subject = lodash_1.union(subjects, geneProductishTerms);
            }
            return ds;
        })
            .toArray()
            .map(function (dataSources) {
            dataSources.sort(function (a, b) {
                var conventionalNameA = a.conventionalName;
                var conventionalNameB = b.conventionalName;
                if (conventionalNameA > conventionalNameB) {
                    return 1;
                }
                else if (conventionalNameA < conventionalNameB) {
                    return -1;
                }
                else {
                    return 0;
                }
            });
            return dataSources;
        })
            .do(function (dataSources) {
            that.setState({ dataSources: dataSources });
        })
            .subscribe(null, console.error);
    };
    return DataSourceSelect;
}(React.Component));
exports.DataSourceSelect = DataSourceSelect;
//# sourceMappingURL=data:application/json;base64,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


//////////////////
// WEBPACK FOOTER
// ./~/bridgedb/lib/components/DataSourceSelect.js
// module id = 269
// module chunks = 0